import Verbindingen from "./Verbindingen"
import DonutCirkel from "./DonutCirkel"
import CirkelMetIconen from "./CirkelMetIconen"
import MiddenCirkel from "./MiddenCirkel"
import Sectoren from "./Sectoren"

function Cirkels({ settings, data, iconPositions, connectionChains,
  circleWidth, middleRadius, clickSelection, setClickSelection, linkPathsPerIcon,
  hoverSelection, setHoverSelection, chartClicked, svgWidth,
  chainSelection, setChainSelection, circleWidthImpacts,
  partijenOptions, setPartijenOptions, landschapOptions, setLandschapOptions }) {

  // de cirkel die onderop ligt
  const middenCirkel = <MiddenCirkel middleRadius={middleRadius} circleWidth={circleWidth}
    chartClicked={chartClicked} />;

  // donut cirkels die over de middencirkel heenliggen. Dezen zijn altijd
  // zichtbaar
  const witteDonutCirkelsBottom = [1,2,3].map(circleID => {
    return (
      <g key={circleID}>
        <DonutCirkel
          middleRadius={middleRadius}
          circleID={circleID*2}
          circleWidth={circleWidth}
          chartClicked={chartClicked}
          color='white'
          visibility='visible'
          textFlag={false}
        />
      </g>
    )
  })

  // daarbovenop liggen de verbindingen tussen de iconen
  const verbindingen = <Verbindingen data={data} iconPositions={iconPositions} circleWidth={circleWidth}
    hoverSelection={hoverSelection} connectionChains={connectionChains}
    clickSelection={clickSelection} linkPathsPerIcon={linkPathsPerIcon}
    chainSelection={chainSelection} circleWidthImpacts={circleWidthImpacts} />;

  // dan de iconen in cirkels, afhankelijk van hun typenr
  const cirkelsMetIconen = [1,2,3,4].map(circleID => {
    const iconData = data.filter(d => +d.typenr === circleID)
    return (
      <g key={circleID}>
        <CirkelMetIconen
          data={data}
          middleRadius={middleRadius}
          iconPositions={iconPositions}
          iconData={iconData}
          circleWidth={circleWidth}
          circleWidthImpacts={circleWidthImpacts}
          hoverSelection={hoverSelection}
          setHoverSelection={setHoverSelection}
          connectionChains={connectionChains}
          clickSelection={clickSelection}
          setClickSelection={setClickSelection}
          chainSelection={chainSelection}
          setChainSelection={setChainSelection}
          landschapOptions={landschapOptions}
          partijenOptions={partijenOptions}
          setLandschapOptions={setLandschapOptions}
          setPartijenOptions={setPartijenOptions}
        />
      </g>
    )
  })

  // als laatste daarbovenop liggen dezelfde donutcirkels. Deze zijn er om de
  // oorzaak en effect iconen te verbergen in het beginscherm. Als er een hover of click is verdwijnen
  // deze donutcirkels en worden er oorzaak en effect iconen zichtbaar
  const witteDonutCirkelsTop = [1,2,3].map(circleID => {
    let donutVisibility = 'visible';
    if(clickSelection >= 0 || hoverSelection >= 0){
      donutVisibility = 'hidden';
    }
    return (
      <g key={circleID}>
        <DonutCirkel
          middleRadius={middleRadius}
          circleID={circleID*2}
          circleWidth={circleWidth}
          chartClicked={chartClicked}
          color='white'
          visibility={donutVisibility}
          textFlag={true}
        />
      </g>
    )
  })

  return (
    <g className='Cirkels' transform={`translate(${svgWidth/2},${settings.height/2})`}>

      {middenCirkel}

      {witteDonutCirkelsBottom}

      {verbindingen}

      <Sectoren data={data} circleWidth={circleWidth} middleRadius={middleRadius}
       clickSelection={clickSelection} connectionChains={connectionChains}
       hoverSelection={hoverSelection} chainSelection={chainSelection} />

      {cirkelsMetIconen}

      {witteDonutCirkelsTop}


    </g>
  );


}

export default Cirkels;
